import * as Types from "./constants";

export const setTour = (value) => ({ type: Types.SET_TOUR, payload: value });

export const logOut = (value) => ({
  type: Types.LOG_OUT_SUCCESS,
  payload: value,
});

export const signInRequest = (form) => ({
  type: Types.SIGN_IN_REQUESTED,
  payload: form,
});

export const closeDrawerMenu = () => ({
  type: Types.CLOSE_DRAWER,
  payload: false,
});
export const toggleDrawerMenu = () => ({ type: Types.TOGGLE_DRAWER });

export const toggleProfile = () => ({ type: Types.TOGGLE_PROFILE });

export const closeProfile = () => ({
  type: Types.CLOSE_PROFILE,
  payload: false,
});

export const searchValue = (value) => ({
  type: Types.SEARCH_VALUE,
  payload: value,
});

export const changeThemeMode = (value) => ({
  type: Types.CHANGE_THEME,
  payload: value,
});

export const toggleLoginSignUpModal = (value) => ({
  type: Types.TOGGLE_LOGIN_SIGNUP_MODAL,
  payload: value,
});

export const checkedAccessSignup = () => ({
  type: Types.CHECKED_ACCESS_SIGNUP,
});

export const checkedAccessLogin = () => ({ type: Types.CHECKED_ACCESS_LOGIN });

export function setForgetPasswordStep(value) {
  return {
    type: Types.FORGET_PASSWORD_STEP,
    payload: value,
  };
}

export function getLastUSerSearches() {
  return {
    type: Types.GET_SEARCH_HISTORY_RESULT_REQUESTED,
  };
}

export function getProfileDetail(value) {
  return {
    type: Types.GET_PROFILE_REQUESTED,
    payload: value,
  };
}

export function setNotificationsSeen(value) {
  return {
    type: Types.SET_NOTIFICATIONS_SEEN_REQUESTED,
    payload: value,
  };
}

export function getMyBoomList(page) {
  return {
    type: Types.GET_MY_BOOM_REQUESTED,
    payload: page,
  };
}
export function getExtraMyBoomList(page) {
  return {
    type: Types.GET_EXTRA_MY_BOOM_REQUESTED,
    payload: page,
  };
}
export function setBoomListInActivityPage(activities) {
  return {
    type: Types.GET_MY_BOOM_SUCCESS,
    payload: activities,
  };
}

export function getActivitySearchList(params) {
  return {
    type: Types.GET_ACTIVITY_SEARCH_REQUESTED,
    payload: params,
  };
}

export function setDefaultForeHasMore2() {
  return {
    type: Types.SET_TRUE_FOR_HAS_MORE_2,
  };
}

export function setSearchActivityQuery(params) {
  return {
    type: Types.SET_SEARCH_ACTIVITY_QUERY,
    payload: params,
  };
}

export function getExtraActivitySearchList(params) {
  return {
    type: Types.GET_EXTRA_ACTIVITY_SEARCH_REQUESTED,
    payload: params,
  };
}
export function setSearchListInActivityPage(activities) {
  return {
    type: Types.GET_ACTIVITY_SEARCH_SUCCESS,
    payload: activities,
  };
}
export function setAllTabPageOne() {
  return {
    type: Types.SET_ALL_TAB_PAGE_ONE,
  };
}

export function getMyActivity(payload) {
  return {
    type: Types.GET_MY_ACTIVITY_REQUESTED,
    payload,
  };
}

export function getMyFallowing() {
  return {
    type: Types.GET_MY_FOLLOWING_REQUESTED,
  };
}

export function setResetTab2(value) {
  return {
    type: Types.SET_RESET_TAB_2,
    payload: value,
  };
}

export function setMyActivityFilter(value) {
  return {
    type: Types.SET_MY_ACTIVITY_FILTER,
    payload: value,
  };
}

export function setMyActivityList(value) {
  return {
    type: Types.SET_MY_ACTIVITY_LIST,
    payload: value,
  };
}

export function removeMyActivity(slug) {
  return {
    type: Types.REMOVE_MY_ACTIVITY,
    payload: slug,
  };
}

export function getSuggestedFollowingList(slug) {
  return {
    type: Types.GET_SUGGESTED_FOLLOWING_LIST_REQUESTED,
    payload: slug,
  };
}

export function setScrollToBoom(position) {
  return {
    type: Types.SET_SCROLL_TO_BOOM,
    payload: position,
  };
}

export function setScrollToSearch(position) {
  return {
    type: Types.SET_SCROLL_TO_SEARCH,
    payload: position,
  };
}

export function setScrollToMyActivity(position) {
  return {
    type: Types.SET_SCROLL_TO_MY_ACTIVITY,
    payload: position,
  };
}

export function setSearchFilterDrawerOpen(boolean) {
  return {
    type: Types.SET_SEARCH_FILTER_DRAWER_OPEN,
    payload: boolean,
  };
}
export function setSearchFilterDrawerOpenMobile(boolean) {
  return {
    type: Types.SET_SEARCH_FILTER_DRAWER_OPEN_MOBILE,
    payload: boolean,
  };
}
export function setMyActivityFilterDrawerOpenMobile(boolean) {
  return {
    type: Types.SET_MY_ACTIVITY_FILTER_DRAWER_OPEN_MOBILE,
    payload: boolean,
  };
}
export function setMessagingOpenMobileBlur(boolean) {
  return {
    type: Types.SET_MESSAGING_OPEN_MOBILE_BLUR,
    payload: boolean,
  };
}
//home
export function getHomeData() {
  return {
    type: Types.HOME_DATA_REQUESTED,
  };
}

//schoolSlug
export function getMoreSchoolActivities(payload) {
  return {
    type: Types.SCHOOL_DATA_REQUESTED,
    payload,
  };
}
